import { ViewSecondaryAnalysisComponent } from './view-secondary-analysis.component';
import { useParams } from 'react-router';
import { useDataRequestAnonymously } from '@vivli/features/data-requests/infrastructure/hook';
import { PublishingContentComponent } from './forms/approved-request-publish-form/publishing-content.component';

export const ViewSecondaryAnalysisContainerComponent = () => {
    const { dataRequestDoi } = useParams();
    const { dataRequest } = useDataRequestAnonymously(dataRequestDoi);
    const isPublished = dataRequest?.publishing?.publishingRules.publishedStatus === 'Published';

    if (!isPublished) {
        return <ViewSecondaryAnalysisComponent dataRequest={dataRequest} />;
    } else {
        return (
            <PublishingContentComponent
                dataRequest={dataRequest}
                isConfigMode={false}
                arrayNameStudies={null}
                fieldsStudies={null}
                arrayNameDisclosures={null}
                fieldsDisclosures={null}
            />
        );
    }
};
